import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Form } from "react-final-form";
import { setPage, setSearch } from "src/features/Utils/mutators";
import PropTypes from "prop-types";

import Search from "./Search";
import ShowTotal from "./ShowTotal";
import Table from "./Table";
import Paging from "./Pagination";
import NotFound from "src/features/Components/NoResults";

import { fetchList } from "./ducks";

const initialValues = {
  name: "",
  province: "",
  page: 1,
  limit: 10,
  // store searched fields in order to handle paging
  searched: {
    name: "",
    province: "",
  },
};

function Index(props) {
  const dispatch = useDispatch();
  const fetching = useSelector((state) => state.allMember.fetching);
  const total = useSelector((state) => state.allMember.total);
  const list = useSelector((state) => state.allMember.list);

  const handleFetchList = (values = initialValues) => {
    dispatch(fetchList(values));
  };

  useEffect(() => {
    dispatch(fetchList());
  }, [dispatch]);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={({ searched, page, limit, ...values }, { mutators }) => {
        // values will be set in 'searched'
        mutators.setSearch(values);
        // reset page when search
        mutators.setPage(1);
        handleFetchList({ ...values, limit, page: 1 });
      }}
      mutators={{ setPage, setSearch }}
      subscription={{ submitting: true }}
    >
      {({ handleSubmit }) => (
        <div>
          <form onSubmit={handleSubmit}>
            <Search />
          </form>
          <ShowTotal
            total={total}
            fetching={fetching}
            handleFetchList={handleFetchList}
          />
          <Table list={list} actions={props.actions} />
          {!total && <NotFound />}
          <Paging total={total} onFetch={handleFetchList} />
        </div>
      )}
    </Form>
  );
}

Index.propTypes = {
  actions: PropTypes.arrayOf(PropTypes.func),
};

export default Index;
